import { MarketConfiguration } from "@/config/markets/const";
import getVatRateFromProduct from "@/utils/elevate/getVatRateFromProduct";
import type { CustomProduct } from "@apptus/esales-api";
import type { CartItemInput } from "@repo/core/cart";

export default function createCartItem({
  product,
  marketConfig,
  ...props
}: Partial<CartItemInput> & {
  product: CustomProduct;
  marketConfig: MarketConfiguration;
}): CartItemInput {
  const vatRate = getVatRateFromProduct(product, marketConfig);
  const [variant] = product.variants;

  return {
    partNo: variant?.key ?? product.key,
    vatRate,
    quantity: 1,
    ...props,
    extras: {
      variant: product.name,
      product_url: product.link,
      stock_status: product.custom?.itemStatus?.[0]?.id,
      ...props.extras,
    },
  };
}
